import React, { useEffect, useRef, useState } from 'react';
import { faqs } from '../data/mock';
import { Badge } from './ui/badge';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="faq" ref={ref} className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className={`text-center mb-16 scroll-fade-in ${isVisible ? 'is-visible' : ''}`}>
          <Badge className="bg-teal-50 text-teal-700 border-teal-200 px-4 py-1.5 text-sm font-medium mb-6">
            FAQ
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight mb-5">
            Frequently Asked{' '}
            <span className="text-teal-600">Questions</span>
          </h2>
          <p className="text-lg text-slate-500">
            Find answers to the most commonly asked questions about ENIAC Coaching Centre.
          </p>
        </div>

        {/* Accordion */}
        <div className={`scroll-fade-in ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: '200ms' }}>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={faq.id}
                value={`faq-${faq.id}`}
                className="bg-slate-50 hover:bg-slate-100/80 border border-slate-100 rounded-2xl px-6 overflow-hidden transition-colors duration-300 data-[state=open]:bg-teal-50/50 data-[state=open]:border-teal-100"
              >
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-slate-800 hover:no-underline py-5 [&[data-state=open]]:text-teal-700">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
